import React, { useState } from "react";
import "./FindSchool.css";
import logo from '../../assets/images/brandlogo.png'
import { Link } from "react-router-dom";
import { FaFacebookF } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaPinterest } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import MainHeader from "../../authorpanel/components/mainheader/MainHeader";

const FindSchool = () => {
  const [search, setSearch] = useState("");

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Search value:", search);
    setSearch("")
  };

  return (
    <>
      <MainHeader />
      <main className="main bg-main-find">
        <div className="findbooks h-100">
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-lg-8">
                <div className="findbooks-content">
                  <div className="row g-2">
                    <div className="col-xl-12">
                      <div className="find-form">
                        <h1>Find Your Event</h1>
                        <p className="findYourSchoolText"> Simply search using your event, city, state, or ZIP code. Plus, you can set up an eWallet account and explore many
                          other features. Let's get started!
                        </p>

                        <form onSubmit={handleSubmit}>
                          <div className="findbooks-bar">
                            <div className="input-group">
                              <input
                                type="search"
                                placeholder="Enter Your Organization Name"
                                name="search"
                                className="form-control"
                                value={search}
                                onChange={handleChange}
                              />
                              <div className="input-group-prepend">
                                <button type="submit" className="btn btn-link">
                                  <i className="fa fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="Desktopfooterpart">
        <div className='container'>
          <div className='row'>
            <a href="/" className='col-lg-3'>
              <div className="Desktopfooterlogo h-100 d-flex align-items-center justify-content-start">
                <img src={logo} className="img-fluid" />
                <div className="desktopfooterbrandTitles">
                  <h6>AuthorMeet</h6>
                  <p>Powered by: Bookworm Central</p>
                </div>
              </div>
            </a>
            <div className='col-lg-3'>
              <div className="desktopfooterleft h-100 d-flex align-items-center justify-content-start">
                <div className="Desktopfootermidtext">
                  <p> Connects readers with authors, offering personalized book purchases, live events, and
                    meaningful interactions that bring stories to life.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className="desktopfooterright h-100 d-flex align-items-end flex-column">
                <div className='desktopsocialIcons d-flex align-items-center justify-content-end mb-3'>
                  <h4 className='me-3'> Connect with us: </h4>
                  <Link className="desktopsocialBoxes desktopsocialcolorOne me-2 d-flex align-items-center justify-content-center">
                    <FaFacebookF className="desktopsocialsingleIcon" />
                  </Link>
                  <Link className="desktopsocialBoxes desktopsocialcolorTwo me-2 d-flex align-items-center justify-content-center">
                    <FaInstagram className="desktopsocialsingleIcon" />
                  </Link>
                  <Link className="desktopsocialBoxes desktopsocialcolorThree me-2 d-flex align-items-center justify-content-center">
                    <FaSquareXTwitter className="desktopsocialsingleIcon" />
                  </Link>
                  <Link className="desktopsocialBoxes desktopsocialcolorFour d-flex align-items-center justify-content-center">
                    <FaPinterest className="desktopsocialsingleIcon" />
                  </Link>
                </div>
                <div className="desktopfootermailId">
                  <h6> Contact Us: <span className='ms-4'> outreach@bookwormcentral.com </span></h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>

  );
};

export default FindSchool;